export default __webpack_public_path__ + "static/media/RodPump1.20bbaa23.png";